<script>
    let id = Math.round(Date.now()/(Math.random(1)*10));

    export let value = "";
    export let label = "Ingresa el texto a continuación";
    export let placeholder = "Ingresa el texto..."
    export let type = "text";
    export let align = "left";
    export let margin = "0em 0em 1em 0em";
    export let background
    export let color
    export let radius = "5px"


</script>

<style>
    input{
        width:100%;
        height:3em;
        padding:1em;
        border-radius: 0.4em;
        margin: var(--margin);
        text-align:var(--align);
        border:none;
        box-sizing:border-box;
    }

    input::placeholder{
        font-size: 0.8em;
    }

    
</style>

{#if type == "password"}
    <input type="password" {id} {placeholder} bind:value={value} style="--align:{align};--margin:{margin};background:{background};color:{color};border-radius:{radius}" />
{:else}
    <input {id} {placeholder} bind:value={value} style="--align:{align};--margin:{margin}" />
{/if}